export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v1/assets/trial_profile_illustration-742a8dd4a96255901fe79d66b82f70e6.svg";